import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ChangeFilter } from '../../change-filter';
import { PyramidBarService } from './pyramid-bar.service';
import { ChartResizeService } from '../../service/chart-resize.service';
import { ChartDarkModeService } from '../../service/chart-dark-mode.service';
import { pyramidBarData } from './pyramid-bar-interface';
import * as colors from '../../config/colors';
import * as backgroundColor from '../../config/backgroundColor';
import { ECharts } from 'echarts';
import { initOpts } from '../../config/initOpts';
import * as _ from 'lodash'

export type axisLabelRotate = 'leftSmallAngle' | 'leftBigAngle' | 'rightSmallAngle' | 'rightBigAngle';
@Component({
  selector: 'bcac-pyramid-bar',
  templateUrl: './pyramid-bar.component.html',
  styleUrls: ['./pyramid-bar.component.scss']
})
export class PyramidBarComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private pyramidBarService: PyramidBarService,
    private chartResizeService: ChartResizeService,
    private chartDarkModeService: ChartDarkModeService
  ) { }


  options: any = this.pyramidBarService.getPyramidBarChartDefaultOption();

  public _bcacChartTitle: { show: boolean, label: string } = {
    show: true, label: "图表标题"
  }
  // 输入图标题
  @Input()
  set bcacChartTitleText(text: string) {
    this._bcacChartTitle.label = text
    this._bcacChartFileName = text;
  }
  // 图标题是否显示
  @Input()
  set bcacChartShowTitle(show: boolean) {
    this._bcacChartTitle.show = show;
  }
  // 下载图片名称
  public _bcacChartFileName: string = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }
  // 是否显示toolbox
  @Input()
  set bcacChartShowToolbox(show: boolean) {
    // this.pyramidBarService.changeToolboxShow(this.options, show)
    // this.updateOptions()
  }

  // 输入是否显示图例
  @Input()
  set bcacChartShowLegend(bcacLegendShow: boolean) {
    this.pyramidBarService.changeLegendShow(this.options, bcacLegendShow);
    this.updateOptions()
  }

  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(chartLoading: boolean) {
    this._bcacChartLoading = chartLoading;
  }

  // 保存传入的数据
  bcacData;
  @Input()
  set bcacChartData(bcacChartData: pyramidBarData) {

    if (!_.isPlainObject(bcacChartData)) {
      bcacChartData = {
        seriesName: [],
        stack: '',
        xData: [],
        yData: []
      }
    }
    this.pyramidBarService.changeChartData(this.options, bcacChartData)

    this.updateOptions()
  };

  // 输入tooltip的单位
  @Input()
  set bcacTooltipUnit(tooltipUnit: string) {
    this.pyramidBarService.changeTooltip(this.options, tooltipUnit)
    this.updateOptions();
  }
  // x轴Name
  @Input()
  set bcacXAxisName(xAxisName: string) {
    this.pyramidBarService.changeXAxisName(this.options, xAxisName)
    this.updateOptions();
  }
  // 输入y轴名
  @Input()
  set bcacYAxisName(yAxisName: string) {
    this.pyramidBarService.changeYAxisName(this.options, yAxisName)
    this.updateOptions();
  }
  // 输入y轴名距离
  @Input()
  set bcacYAxisNameGap(yAxisNameGap: number[]) {
    this.pyramidBarService.changeYAxisNameGap(this.options, yAxisNameGap);
    this.updateOptions();
  }
  // x轴label的旋转 
  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: axisLabelRotate) {
    this.pyramidBarService.changeXAxisLabelRotate(this.options, xAxisLabelRotate);
    this.updateOptions();
  }
  // y轴label的旋转
  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: axisLabelRotate) {
    this.pyramidBarService.changeYAxisLabelRotate(this.options, yAxisLabelRotate);
    this.updateOptions();
  }

  _selectList: { value: string | number, optList: { label: string, value: any }[] }[] = [];
  // 数据选择区域
  @Input()
  set bcacDataSourceList(selectList: any) {
    if (Array.isArray(selectList)) {
      if (selectList.length > 0 && selectList[0].hasOwnProperty('optList')) {
        this._selectList = selectList;
      } else {
        selectList = [];
        this._selectList = selectList;
      }
    } else {
      selectList = []
      this._selectList = selectList;
    }
  }

  singleSelectIconShow: boolean = false;
  intervalData: any[] = []; //interval 数据
  intervalSelectedData: string | number = ''; //当前选择的interval
  @Input() //输入interval数据
  set bcacIntervalData(value: any[]) {
    if (Array.isArray(value) && value.length > 0) {
      this.intervalData = value;
      this.singleSelectIconShow = true;
      if (value.length == 1) {
        this.axisScaleChange(value[0].value);
        this.singleSelectIconShow = false;
      }
    } else {
      this.singleSelectIconShow = false;
    }
  }

  isSmallMode: boolean = false;
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.isSmallMode = true;
      this.changeCardPadding("0rem");
      this.chartResizeService.openPyramidSmallMode(this.options, this.isSmallMode);
      // this.chartResizeService.configSplitLine(false, this.options);
      this.updateOptions();
    } else {
      this.isSmallMode = false;
    }
  }

  @Input()
  set bcacAxisSplitLine(axisSplitLineShow: boolean) {
    if (axisSplitLineShow == true) {
      this.chartResizeService.configSplitLine(true, this.options, 'x');
    } else {
      this.chartResizeService.configSplitLine(false, this.options, 'x');
    }
  }

  cardPadding = "1rem";
  changeCardPadding(cardPadding: string) {
    this.cardPadding = cardPadding;
  }

  chartTitleColor = '';
  isDarkMode: boolean = false;
  @Input()
  set bcacDarkMode(darkMode: boolean | string) {
    this.isDarkMode = darkMode ? true : false;

    this.changeChartTitleColor(darkMode);
    this.changeCardBackgroundColor(darkMode);
    this.chartDarkModeService.openDarkMode(this.options, darkMode);
  }

  @Input()
  set bcacColors(chartColors: string[]) {
    if (Array.isArray(chartColors)) {
      this.commonService.changeChartColors(this.options, chartColors)
    }
  }

  @Input()
  set bcacXAxisMax(xAxisMax: number[]) {
    this.pyramidBarService.changeXAxisMax(this.options, xAxisMax);
  }

  @Input()
  set bcacXAxisInterval(xAxisInterval: number) {
    this.pyramidBarService.changeXAxisInterval(this.options, xAxisInterval)
  }

  @Output() bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter()

  // 数据源选择变化
  @Output() bcacDataSourceSelectEmit: EventEmitter<any[]> = new EventEmitter<any[]>();
  initOpts;
  ngOnInit() {
    this.initOpts = initOpts;
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.chartInstance, this.options);
    })

  }

  updateOptions() {
    if (this.chartInstance) {
      this.chartInstance.setOption(this.options, true)
    }
  }

  chartInstance: ECharts;
  onChartInit(ec) {
    this.chartInstance = ec;

    this.bcacGetChartInstance.emit(ec);
  }

  // 选择的数据
  selectedData: string = "";


  // 下拉框数据
  dataSourceList: { label: string, value: string }[] = [];

  selectedDataSourceChange($event) {
    this.bcacDataSourceSelectEmit.emit($event);
  }

  axisScaleChange(interval: number | string) {
    this.pyramidBarService.setInterval(this.options, interval)
    this.updateOptions();
  }


  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this.chartTitleColor = ''
    } else {
      this.chartTitleColor = colors.darkModeTextColor;
    }
  }

  cardBgColor = '';
  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this.cardBgColor = darkMode;
    } else if (darkMode) {
      this.cardBgColor = backgroundColor.darkModeBGColor;
    }
  }
}
